import { Box } from '@mui/material';

import { useLocales } from 'src/locales';
import { STATUS_PALETTE, StatusToken } from 'src/theme/status-palette';
import { CatalogPdfJobStatus } from 'src/types';

const STATUS_TOKEN_MAP: Record<CatalogPdfJobStatus, StatusToken> = {
  pending: 'neutral',
  running: 'info',
  done: 'complete',
  failed: 'error',
};

type Props = {
  status: CatalogPdfJobStatus;
};

export default function CatalogPdfStatusBadge({ status }: Props) {
  const { t } = useLocales('catalogPdf');

  const pair = STATUS_PALETTE[STATUS_TOKEN_MAP[status]];
  const label = t(`status_${status}`);

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        typography: 'caption',
        px: 1.25,
        py: 0.25,
        borderRadius: '99px',
        fontWeight: 'fontWeightMedium',
        whiteSpace: 'nowrap',
        backgroundColor: pair.light.bg,
        color: pair.light.color,
        '[data-color-scheme="dark"] &': {
          backgroundColor: pair.dark.bg,
          color: pair.dark.color,
        },
      }}
    >
      {label}
    </Box>
  );
}
